
export default function downloadLink(link, filename) {
    const autoDownloadLink = document.createElement('a');
    autoDownloadLink.href = link;
    autoDownloadLink.setAttribute('download', filename);
    autoDownloadLink.click();
}
